import AccessLevelPanel from "./panels/AccessLevelPanel";


const tabRoutes = [
  {
    name: "Information Access Level",
    path: "/access-level",
    component: <AccessLevelPanel />
  }
  // {
  //   name: "Deals",
  //   path: "/deals",
  //   component: <DealsPanel />,
  // },
  // {
  //   name: "Offers",
  //   path: "/offers",
  //   component: <OffersPanel />,
  // },
];

export default tabRoutes;

